import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41956492"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "columns is-centered is-vcentered" }
const _hoisted_2 = { class: "column is-one-quarter" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title is-centered" }, "Plink Sensor", -1))
const _hoisted_4 = { class: "field" }
const _hoisted_5 = { class: "control has-icons-left" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon is-small is-left" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user" })
], -1))
const _hoisted_7 = { class: "field" }
const _hoisted_8 = { class: "control has-icons-left" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon is-small is-left" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lock" })
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "button is-primary"
}, "Entrar", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AuthError = _resolveComponent("AuthError")!
  const _component_PermissionError = _resolveComponent("PermissionError")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          class: "box",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
        }, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "input",
                placeholder: "Usuário",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.username) = $event))
              }, null, 512), [
                [_vModelText, _ctx.form.username]
              ]),
              _hoisted_6
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                type: "password",
                class: "input",
                placeholder: "**********",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.password) = $event))
              }, null, 512), [
                [_vModelText, _ctx.form.password]
              ]),
              _hoisted_9
            ])
          ]),
          _hoisted_10
        ], 32)
      ])
    ]),
    (_ctx.loginError)
      ? (_openBlock(), _createBlock(_component_AuthError, {
          key: 0,
          onOnDismiss: _ctx.closeErrorMessage
        }, null, 8, ["onOnDismiss"]))
      : _createCommentVNode("", true),
    (_ctx.permissionError)
      ? (_openBlock(), _createBlock(_component_PermissionError, {
          key: 1,
          onOnDismiss: _ctx.closePermissionErrorMessage
        }, null, 8, ["onOnDismiss"]))
      : _createCommentVNode("", true)
  ], 64))
}